import React, { FC } from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

interface SortableItemProps {
  isPinned: boolean
  children: ({
    dragHandleProps,
    setActivatorNodeRef,
    isDragging,
  }: {
    dragHandleProps: React.HTMLAttributes<HTMLElement>
    setActivatorNodeRef?: (element: HTMLElement | null) => void
    isDragging: boolean
  }) => React.ReactNode
  id: number | string
}

export const SortableItem: FC<SortableItemProps> = ({ isPinned, children, id }) => {
  const sortable = useSortable({
    id: id,
    disabled: isPinned,
  })

  const { attributes, listeners, setNodeRef, transform, transition, setActivatorNodeRef, isDragging } = sortable

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} style={isPinned ? {} : style}>
      {children({
        dragHandleProps: isPinned ? {} : { ...listeners, ...attributes },
        setActivatorNodeRef: isPinned ? undefined : setActivatorNodeRef,
        isDragging: isDragging || false,
      })}
    </div>
  )
}
